module.exports = __webpack_public_path__ + "img/promotion_2.1287dad3.png";